import { Injectable } from "@angular/core";
import { QueryEntity } from "@datorama/akita";
import { ISharedResourceState, SharedResourceStore } from "./sharedResource.store";

@Injectable({
  providedIn: 'root'
})
export class SharedResourceQuery extends QueryEntity<ISharedResourceState> {
  constructor(protected store: SharedResourceStore) {
    super(store);
  }
}
